import { render, staticRenderFns } from "./salarypartpay.vue?vue&type=template&id=4d04390a"
import script from "./salarypartpay.vue?vue&type=script&lang=js"
export * from "./salarypartpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports